import { useRecoilValue } from "recoil";
import { loginState } from "../stores/loginState";
import { useMutation } from "react-query";
import Swal from "sweetalert2";
import {
  LogenInstance,
} from "./instance";

const useGetLoginToken = () => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState);

  // TODO API 성공 시
  const handleSuccess = (data) => {
    if (data.result === "fail") { // 송장번호 입력 오류
      Swal.fire({
        icon: "error",
        title: "NVR프로그램 실행에\n실패하였습니다.",
        confirmButtonText: "확인",
      });
    } else if (data.result === "success") { // 조회 성공 시
      window.location.href = "vass://" + data.data;
    }
  };

  // TODO API 실패 시
  const handleError = (error) => {
    console.log(error);
  };

  // TODO Mutation 옵션 설정
  const mutationOptions = {
    onSuccess: handleSuccess,
    onError: handleError,
  };

  // TODO API 요청 데이터 생성
  const createPostData = () => ({
    bran_cd: login.branchCode,
  });

  // NOTE 회사 별 인스턴스
  const instanceMap = {
    LOGEN: LogenInstance,
  };

  // TODO API 리퀘스트 정보
  const mutationFunction = () => {
    const instance = instanceMap[login.company];
    if (!instance) throw new Error("Invalid company");
    return instance.post("/watcher/login-key", createPostData());
  };

  // NOTE 데이터 요청 관리
  return useMutation("getWorkInvoiceList", mutationFunction, mutationOptions);
};

export default useGetLoginToken;
